module.exports = __webpack_public_path__ + "img/calendar-29_fill.78cc5052.svg";